/* GSB cart drawer (snippets/cart-drawer.liquid): "Make it 10 perfumes" upgrade and the empty-cart starter button.
   Coupons, bought-together "+ Add", free gift and totals stay in gsb-cart-progress.js. */
(() => {
  if (window.__gsbCartDrawer) return;
  window.__gsbCartDrawer = true;

  const sectionsParam = () => {
    const ids = ['cart-icon-bubble'];
    if (document.querySelector('cart-drawer')) ids.push('cart-drawer');
    return { sections: ids, sections_url: window.location.pathname };
  };
  const add = (items) =>
    fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, ...sectionsParam() }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status) throw new Error(data.description || 'Could not add to cart. Please try again.');
        return data;
      });
  /* Drawer plus the /cart page sections when they are on the page */
  const allSections = () => {
    const p = sectionsParam();
    ['main-cart-items', 'main-cart-footer'].forEach((id) => {
      const el = document.getElementById(id);
      if (el && el.dataset.id) p.sections.push(el.dataset.id);
    });
    return p;
  };
  /* Same swap as gsb-cart-progress.js: lines + footer from the fresh drawer, the cart page, then the header bubble */
  const render = (sections) => {
    if (!sections) return;
    const parse = (h) => new DOMParser().parseFromString(h, 'text/html');
    if (sections['cart-drawer']) {
      const doc = parse(sections['cart-drawer']);
      ['cart-drawer-items', '.cart-drawer__footer'].forEach((sel) => {
        const t = document.querySelector(`cart-drawer ${sel}`), n = doc.querySelector(sel);
        if (t && n) t.replaceWith(n);
      });
    }
    ['main-cart-items', 'main-cart-footer'].forEach((id) => {
      const el = document.getElementById(id), html = el && sections[el.dataset.id];
      const target = html && el.querySelector('.js-contents'), source = html && parse(html).querySelector('.js-contents');
      if (target && source) target.innerHTML = source.innerHTML;
    });
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      const n = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (n) bubble.innerHTML = n.innerHTML;
    }
  };

  const updateCart = (body) =>
    fetch(`${(window.routes && window.routes.cart_update_url) || '/cart/update'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, ...allSections() }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status) throw new Error(data.description || 'Could not update the cart. Please try again.');
        render(data.sections);
        return data;
      });

  /* x on the free 5-tester pack (drawer or /cart page): take ₹299 off instead with the skip code (gsb-gift-config).
     gsb-cart-progress.js leaves the pack out while that code is on the cart.
     No skip code: just remove the pack, and remember it so it isn't added straight back. */
  document.addEventListener('click', (e) => {
    const rm = e.target.closest && e.target.closest('cart-remove-button');
    const line = rm && rm.closest('[data-gsb-gift-line]');
    if (!line) return;
    const code = window.gsbGift && window.gsbGift.skipCode;
    if (!code) {
      try { sessionStorage.setItem('gsbGiftOff', '1'); } catch (err) {}
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    rm.querySelectorAll('button, a').forEach((b) => b.setAttribute('aria-disabled', 'true'));
    updateCart({ updates: { [line.dataset.gsbGiftLine]: 0 }, discount: code }).catch(() => window.location.reload());
  }, true);

  /* "+ FREE 5-tester pack" lines only while the free-gift offer is on (gsb-gift-config) */
  if (window.gsbGift) document.documentElement.classList.add('gsb-gift-on');

  document.addEventListener('click', (e) => {
    /* 50 ml -> 100 ml: drop the 50 ml line, set the 100 ml quantity (one request) */
    const size = e.target.closest('[data-gsb-cd-size]');
    if (size && !size.disabled) {
      const label = size.textContent;
      const msg = size.closest('.gsb-cd-up').querySelector('[data-gsb-cd-up-msg]');
      size.disabled = true;
      size.textContent = 'Updating…';
      fetch(`${(window.routes && window.routes.cart_update_url) || '/cart/update'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: { [size.dataset.key]: 0, [size.dataset.to]: Number(size.dataset.qty) }, ...sectionsParam() }),
      })
        .then((r) => r.json())
        .then((data) => {
          if (data.status) throw new Error(data.description || 'Could not update the cart. Please try again.');
          render(data.sections);
        })
        .catch((err) => {
          size.disabled = false;
          size.textContent = label;
          if (msg) {
            msg.textContent = err.message;
            msg.hidden = false;
          }
        });
      return;
    }
    /* Back to the free pack: drop the skip code; gsb-cart-progress.js adds the pack again */
    const back = e.target.closest('[data-gsb-gift-back]');
    if (back && !back.disabled) {
      back.disabled = true;
      back.textContent = 'Adding the testers…';
      updateCart({ discount: '' }).catch(() => { back.disabled = false; });
      return;
    }
    const up = e.target.closest('[data-gsb-cd-upgrade]');
    if (up && !up.disabled) {
      const label = up.textContent;
      const msg = up.closest('.gsb-cd-up').querySelector('[data-gsb-cd-up-msg]');
      up.disabled = true;
      up.textContent = 'Adding…';
      const items = up.dataset.items.split(',').filter(Boolean).map((id) => ({ id: Number(id), quantity: 1, properties: { _gsb_pack: up.dataset.pack } }));
      add(items)
        .then((data) => render(data.sections))
        .catch((err) => {
          up.disabled = false;
          up.textContent = label;
          if (msg) {
            msg.textContent = err.message;
            msg.hidden = false;
          }
        });
      return;
    }
    const starter = e.target.closest('[data-gsb-cd-add]');
    if (starter && !starter.disabled) {
      starter.disabled = true;
      add([{ id: Number(starter.dataset.gsbCdAdd), quantity: 1 }])
        .then((data) => {
          const drawer = document.querySelector('cart-drawer');
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        })
        .catch(() => { starter.disabled = false; });
    }
  });
})();
